var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotVerifiedIncomeAssetsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8924 18.4784L20.5232 23.6318H18.677L18.3078 18.4784V9.59961H20.8924V18.4784ZM19.6001 26.3638C20.195 26.3638 20.677 26.5501 21.0463 26.9226C21.4155 27.2951 21.6001 27.7815 21.6001 28.3817C21.6001 28.9819 21.4155 29.4683 21.0463 29.8408C20.677 30.2133 20.195 30.3996 19.6001 30.3996C19.0052 30.3996 18.5232 30.2133 18.1539 29.8408C17.7847 29.4683 17.6001 28.9819 17.6001 28.3817C17.6001 27.7815 17.7847 27.2951 18.1539 26.9226C18.5232 26.5501 19.0052 26.3638 19.6001 26.3638Z",
    fill: "#FF8C6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FF8C6A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerifiedIncomeAssetsSmall);
export default __webpack_public_path__ + "static/media/not-verified-income-assets-small.50a840a3.svg";
export { ForwardRef as ReactComponent };